import angular from 'angular';

import {} from './safety.less';

module.exports = angular.module('market.routes.static.safety', [
  require('angular-ui-router'),
])
.config(function($stateProvider) {
  $stateProvider.state('safety', {
    parent: 'root',
    url: '/safety',
    template: require('./safety.jade')(),
    data: {
      meta: {
        titleSuffix: " | Trust and safety",
      }
    },
    controllerAs: 'safetyCtrl',
    controller: class {
      constructor() {
        this.tab = '';
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/static/safety/safety.js
 **/